<template>
  <div>
    <div class="Footer_container__sBLl9">
      <section class="Footer_left__m0Iza">
        <img src="@/assets/logobig.png">
      </section>
      <!--   底部中间菜单   -->
      <section class="Footer_center__EuqPs">
        <div v-for="(item,index) in footerConfig.navigationItems" :key="index" class="Footer_bottom-nav-item__RlEeF">
          <a v-if="item.target" :href="item.link" style="color:inherit;" :target="item.target">{{item.label}}</a>
          <div v-else class="Footer_sm_inline" @click="goToPage(item)">{{item.label}}</div>
        </div>
      </section>
      <!--   底部右侧菜单   -->
      <section class="Footer_right__0hJE5">
          <span class="Footer_sm__YbPDq">
            <div class="Footer_item__sH2D3" @click="weChatClick">
              <div class="icon gtm-tracking">
                <img src="@/assets/40.png" style="width:22px;height: auto;">
              </div>
              <span>微信</span>
              <div class="Footer_tooltip__EY9hX Footer_cn-wechat__qpKm8" :class="{'Footer_tooltip-show__3T9yh':isWeChat}" id="sm-tooltip">
                <img class="socials-qrcode" style="width: 150px;" src="@/assets/jhcode.jpg">
              </div>
            </div>
            <div class="Footer_item__sH2D3" @click="goService">
              <div class="icon gtm-tracking">
                <img src="@/assets/41.png" style="width:20px;height: auto;">
              </div>
              <span>客服中心</span>
            </div>
            <div class="Footer_item__sH2D3">
              <div class="icon gtm-tracking">
                <img src="@/assets/42.png" style="width:20px;height: auto;">
              </div>
              <span>4008289980</span>
            </div>
          </span>
      </section>
    </div>
    <div class="Footer_policy__NPukg">
      <div class="Footer_bottomLegal__yQ0aY">
        <a href="https://beian.miit.gov.cn/" target="_blank"
           rel="noopener noreferrer">Copyright ◎2015常州嘉宏房地产开发有限公司A All Rights Reserved.苏ICP备08020308号</a>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'v-foot',
  data() {
    return {
      isWeChat:false,
      footerConfig: {
        navigationItems: [
          {
            label: "走进嘉宏",
            link: "/about"
          },
          {
            label: "多元业务",
            link: "/dwell"
          },
          {
            label: "客户服务",
            link: "/elegance"
          },
          {
            label: "招采平台",
            link: "https://home.myyscm.com/czjh",
            target: '_blank'
          },
          {
            label: '加入嘉宏',
            link: "/join"
          }
        ],
        socialItems: [
          {
            id: "wechat",
            label: "微信",
            link: "#",
            showToolTip: true,
            class: "cn-wechat",
            icon: "40.png"
          },
          {
            id: "customer-service",
            label: "客服中心",
            link: "https://nwp-su.nio.com/kf/3TW",
            showToolTip: false,
            class: "cn-customer-service",
            icon: "41.png"
          },
          {
            id: "contact",
            label: "4008289980",
            link: "#",
            showToolTip: false,
            class: "cn-contact",
            icon: "42.png"
          }
        ],
        bottomLegal: ""
      }
    }
  },
  watch: {
    obj: {
      handler(newVal, oldVal) {

      }
    }
  },
  methods: {
    weChatClick(){
      this.isWeChat = !this.isWeChat
    },
    goToPage(item){
      if('' != item.link){
        this.$router.push(item.link)
      }
    },
    goService(){
      this.$router.push('/service')
    }
  }
}
</script>
<style scoped lang="scss">

</style>
